import { Injectable } from '@angular/core';
import { configURI } from '../../../shared/apiUrlConfig';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ParComplaintsTasksService {
  load;
  url = environment.configURI;
  private deleteComplaintTaskData = '/complaints/tasks/';

  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  /***
   * Post API to Add a Task for a given Complaint
   * @param data
   * @returns {Observable<R|T>}
   */
  addTaskService(data) {
    return this.httpClient.post(this.url + "/complaints/tasks", data).catch(this.userFriendlyMsgs.errorHandler);
  }

  /***
   * Update API to update the given task for a given Complaint
   * @param taskData
   * @param task_doc_id
   * @returns {Observable<R|T>}
   */
  updateTaskService(taskData, task_doc_id) {
    return this.httpClient.put(this.url+ "/complaints/tasks/" + task_doc_id + "/" + taskData.complaint_id, taskData).catch(this.userFriendlyMsgs.errorHandler);
  }

  /***
   * Delete API to delete a given Complaint
   * @param id
   * @param complaintId
   * @returns {Observable<R|T>}
   */
  deleteComplaintsTasks(id, complaintId) {
    return this.httpClient.delete(`${this.url}${this.deleteComplaintTaskData}${id}` + "/" + `${complaintId}`).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/par_complaints_tasks/par-complaints-tasks.service.ts